export const ENV_FLAGS = [
  'IVCO_49_MOVE_IV_TO_MOBILE',
  'UPSELLING_TOP_OFFERS',
  'POSTHOG_TRACKING',
  'CHE_171_CHAT_ATTACHMENTS',
  'CHE_181_TRAVEL_GUIDE',
  'CHE_184_LUGGAGE_STORAGE_ENABLED',
  'IV_SELFIE_AUTO_CAPTURE',
  'IV_DOCUMENT_AUTO_CAPTURE',
  'GUESTAPP_REDESIGN_ENABLED',
  'UNATTENDED_TERMINAL_ENABLED',
  'GUEST_AUTH_EMAIL_FIRST',
] as const;
